import clsx from 'clsx';
import styles from './course.module.scss';
import { useCallback, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleRight, faAngleUp, faCheck, faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { faSlack } from '@fortawesome/free-brands-svg-icons';
import { getAllLanguages } from '~/api/languages';
import { getAllLevels } from '~/api/levels';

import CodeMirror from '@uiw/react-codemirror';
import { langs } from '@uiw/codemirror-extensions-langs';
import { dracula } from '@uiw/codemirror-theme-dracula';
import { xcodeLight } from '@uiw/codemirror-theme-xcode';

import DateTimePicker from 'react-datetime-picker';
import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';
import TimePicker from 'react-time-picker';
import 'react-time-picker/dist/TimePicker.css';
import { useParams } from 'react-router-dom';
import { createExercise } from '~/api/courses';
import { reFormatedTime } from '~/utils';

const { default: CourseComponent } = require('~/components/Course');

const type_scores = [{ 0: 'Max Score' }, { 1: 'Final Score' }, { 2: 'Average Score' }];

const MainChild = () => {
    const { id, class_topics_id } = useParams();

    const [openFieldForm, setOpenFieldForm] = useState(true);
    const [openFieldForms, setOpenFieldForms] = useState([]);

    const [theme, setTheme] = useState('');

    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');

    const [languages, setLanguages] = useState([]);
    const [languages_, setLanguages_] = useState([]);
    const [openLanguages, setOpenLanguages] = useState(false);

    const [levels, setLevels] = useState([]);
    const [level_, setLevel_] = useState(null);
    const [openLevel, setOpenLevel] = useState(false);

    const [typeScores, setTypeScores] = useState(type_scores);
    const [typeScore, setTypeScore] = useState(0);
    const [openTypeScore, setOpenTypeScore] = useState(false);

    const [initialCodes, setInitialCodes] = useState([]);
    const [solutionCodes, setSolutionCodes] = useState([]);
    const [fullCodes, setFullCodes] = useState([]);

    const [inputTestcase, setInputTestcase] = useState('');
    const [outputTestcase, setOutputTestcase] = useState('');

    const [testcases, setTestcases] = useState([]);

    const [startTime, setStartTime] = useState();
    const [endTime, setEndTime] = useState();
    const [timeLimit, setTimeLimit] = useState();
    const [retries, setRetries] = useState();

    const [errorTitle, setErrorTitle] = useState('');
    const [errorDescription, setErrorDescription] = useState('');
    const [errorLanguage, setErrorLanguage] = useState('');
    const [errorLevel, setErrorLevel] = useState('');

    const handleOpenFieldForms = (index) => {
        const updateOpens = [...openFieldForms];
        updateOpens[index] = !updateOpens[index];
        setOpenFieldForms(updateOpens);
    };

    const handleChangeTitle = (text) => {
        setTitle(text);
    };

    const handleChangeDescription = (text) => {
        setDescription(text);
    };

    const checkLanguage = (languages, language) => {
        for (let i = 0; i < languages.length; i++) {
            if (languages[i].id === language.id) return true;
        }
        return false;
    };

    const handleSelectLanguages = (language) => {
        let newLanguage;
        if (checkLanguage(languages_, language)) {
            newLanguage = languages_.filter((element) => element.id !== language.id);
            setLanguages_(newLanguage);
        } else {
            newLanguage = [...languages_, language];
            setLanguages_(newLanguage);
        }
    };

    const convertLanguages = (languages) => {
        if (languages.length > 0) {
            var stringLanguages = languages[0]['name'];
            for (var i = 1; i < languages.length; i++) {
                stringLanguages = stringLanguages + ', ' + languages[i]['name'];
            }
            return stringLanguages;
        }
    };

    // Level
    const handleSelectLevel = (level) => {
        setLevel_(level);
    };

    // Type score
    const handleSelectTypeScore = (type_score) => {
        setTypeScore(type_score);
    };

    // Timer
    const handleChangeRetries = (_retries) => {
        setRetries(_retries);
    };

    // Code
    const handleCheckEmpty = (type) => {
        // if (language === 'cpp') {
        //     if (type === 'initialCode') {
        //         if (initialCode.length === 0) {
        //             setErrorInitialCode('Missing initial code');
        //             localStorage.setItem('errorCppInitialCode', 'Missing initial code');
        //         }
        //     }
        //     if (type === 'fullCode') {
        //         if (fullCode.length === 0) {
        //             setErrorFullCode('Missing full code');
        //             localStorage.setItem('errorCppFullCode', 'Missing full code');
        //         }
        //     }
        //     if (type === 'solutionCode') {
        //         if (solutionCode.length === 0) {
        //             setErrorSolutionCode('Missing solution code');
        //             localStorage.setItem('errorCppSolutionCode', 'Missing solution code');
        //         }
        //     }
        // } else if (language === 'python') {
        //     if (type === 'initialCode') {
        //         if (initialCode.length === 0) {
        //             setErrorInitialCode('Missing initial code');
        //             localStorage.setItem('errorPythonInitialCode', 'Missing initial code');
        //         }
        //     }
        //     if (type === 'fullCode') {
        //         if (fullCode.length === 0) {
        //             setErrorFullCode('Missing full code');
        //             localStorage.setItem('errorPythonFullCode', 'Missing full code');
        //         }
        //     }
        //     if (type === 'solutionCode') {
        //         if (solutionCode.length === 0) {
        //             setErrorSolutionCode('Missing solution code');
        //             localStorage.setItem('errorPythonSolutionCode', 'Missing solution code');
        //         }
        //     }
        // }
    };

    // Testcases
    const handleChangeInputTestcase = (text) => {
        setInputTestcase(text);
    };

    const handleChangeOutputTestcase = (text) => {
        setOutputTestcase(text);
    };

    const handleChangeCode = (val, language, type) => {
        if (type === 'initial') {
            const updateCode = [...initialCodes];
            updateCode[language.id] = val;
            setInitialCodes(updateCode);
        } else if (type === 'solution') {
            const updateCode = [...solutionCodes];
            updateCode[language.id] = val;
            setSolutionCodes(updateCode);
        } else if (type === 'full') {
            const updateCode = [...fullCodes];
            updateCode[language.id] = val;
            setFullCodes(updateCode);
        }
    };

    const handleAddTestcase = () => {
        const newTestCases = [...testcases, { input: inputTestcase, output: outputTestcase }];
        setTestcases(newTestCases);
        setInputTestcase('');
        setOutputTestcase('');
    };

    const handleSubmitExercise = async () => {
        let problem_languages = [];

        for (let i = 0; i < languages_.length; i++) {
            problem_languages.push({
                language_id: languages_[i].id,
                initialCode: initialCodes[languages_[i].id],
                solutionCode: solutionCodes[languages_[i].id],
                fullCode: fullCodes[languages_[i].id],
            });
        }

        let timeLimitSplit = timeLimit.split(':');
        let time_limit;
        time_limit = JSON.stringify(parseInt(timeLimitSplit[0]) * 60 + parseInt(timeLimitSplit[1]));
        time_limit = time_limit === '0' ? '-1' : time_limit;

        const data = {
            title,
            level_id: level_.id,
            description,
            problem_languages,
            type_score: typeScore,
            testcases,
            class_topics_id,
            time_limit,
            start_time: reFormatedTime(startTime),
            end_time: reFormatedTime(endTime),
            retries,
        };

        const response = await createExercise(data);
        if (response.code === 201) {
            window.location.href = `/courses/${id}/course`;
        }
        console.log(response);
    };

    useEffect(() => {
        setOpenFieldForms(new Array(100).fill(true));
        setInitialCodes(new Array(100).fill(''));
        setTheme(localStorage.getItem('theme'));

        (async () => {
            const fetchLanguages = await getAllLanguages();
            setLanguages(fetchLanguages.data);

            const fetchLevels = await getAllLevels();
            setLevels(fetchLevels);
        })();
    }, []);

    return (
        <div className={clsx(styles.addExercise)}>
            <div className={clsx(styles.header)} onClick={() => setOpenFieldForm(!openFieldForm)}>
                <div className={clsx(styles.headerTitle)}>
                    <span>
                        <FontAwesomeIcon icon={faSlack} />
                    </span>
                    ADD NEW EXERICSE TO ...
                </div>
                {openFieldForm && (
                    <div className={clsx(styles.headerIcon)}>
                        <FontAwesomeIcon icon={faAngleUp} />
                    </div>
                )}
                {!openFieldForm && (
                    <div className={clsx(styles.headerIcon)}>
                        <FontAwesomeIcon icon={faAngleDown} />
                    </div>
                )}
            </div>
            {openFieldForm && (
                <div className={clsx(styles.body)}>
                    <div className={clsx(styles.formField)}>
                        <div
                            className={clsx(styles.formTitle)}
                            onClick={() => {
                                handleOpenFieldForms(0);
                            }}
                        >
                            <div className={clsx(styles.title)}>General Information</div>
                            <div className={clsx(styles.formDropdown)}>
                                {openFieldForms[0] && <FontAwesomeIcon icon={faAngleUp} />}
                                {!openFieldForms[0] && <FontAwesomeIcon icon={faAngleDown} />}
                            </div>
                        </div>
                        {openFieldForms[0] && (
                            <div>
                                <div className={clsx(styles.formInput)}>
                                    <div className={clsx(styles.label)}>
                                        Title
                                        <span>
                                            <FontAwesomeIcon icon={faCircleExclamation} />
                                        </span>
                                    </div>
                                    <div className={clsx(styles.input)}>
                                        <input
                                            type="text"
                                            className={clsx('form-control', styles.formControl)}
                                            id="exampleFormControlInput1"
                                            value={title}
                                            onChange={(event) => handleChangeTitle(event.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className={clsx(styles.formInput)}>
                                    <div className={clsx(styles.label)}>
                                        Languages
                                        <span>
                                            <FontAwesomeIcon icon={faCircleExclamation} />
                                        </span>
                                    </div>
                                    <div className={clsx(styles.input)}>
                                        <div
                                            className={clsx(styles.dropdown)}
                                            onClick={() => setOpenLanguages(!openLanguages)}
                                        >
                                            <div className={clsx(styles.dropdownName)}>
                                                {languages_.length > 0
                                                    ? convertLanguages(languages_)
                                                    : 'Select one or more languages...'}
                                            </div>
                                            <div className={clsx(styles.dropdownIcon)}>
                                                {openLanguages && <FontAwesomeIcon icon={faAngleUp} />}
                                                {!openLanguages && <FontAwesomeIcon icon={faAngleDown} />}
                                            </div>
                                        </div>
                                        {openLanguages && (
                                            <div className={clsx(styles.dropdownBody)}>
                                                {languages.map((language, indexLanguage) => {
                                                    return (
                                                        <div
                                                            className={clsx(styles.dropdownItem)}
                                                            onClick={() => handleSelectLanguages(language)}
                                                        >
                                                            <div className={clsx(styles.dropdownItemTitle)}>
                                                                {language.name}
                                                            </div>
                                                            {checkLanguage(languages_, language) && (
                                                                <div className={clsx(styles.dropdownItemIcon)}>
                                                                    <FontAwesomeIcon icon={faCheck} />
                                                                </div>
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className={clsx(styles.formInput)}>
                                    <div className={clsx(styles.label)}>
                                        Level
                                        <span>
                                            <FontAwesomeIcon icon={faCircleExclamation} />
                                        </span>
                                    </div>
                                    <div className={clsx(styles.input)}>
                                        <div className={clsx(styles.dropdown)} onClick={() => setOpenLevel(!openLevel)}>
                                            <div className={clsx(styles.dropdownName)}>
                                                {level_ ? level_.name : 'Select level...'}
                                            </div>
                                            <div className={clsx(styles.dropdownIcon)}>
                                                {openLevel && <FontAwesomeIcon icon={faAngleUp} />}
                                                {!openLevel && <FontAwesomeIcon icon={faAngleDown} />}
                                            </div>
                                        </div>
                                        {openLevel && (
                                            <div className={clsx(styles.dropdownBody)}>
                                                {levels.map((level, indexLanguage) => {
                                                    return (
                                                        <div
                                                            className={clsx(styles.dropdownItem)}
                                                            onClick={() => handleSelectLevel(level)}
                                                        >
                                                            <div className={clsx(styles.dropdownItemTitle)}>
                                                                {level.name}
                                                            </div>
                                                            {level_ && level.id === level_.id && (
                                                                <div className={clsx(styles.dropdownItemIcon)}>
                                                                    <FontAwesomeIcon icon={faCheck} />
                                                                </div>
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className={clsx(styles.formInput)}>
                                    <div className={clsx(styles.label)}>
                                        Type score
                                        <span>
                                            <FontAwesomeIcon icon={faCircleExclamation} />
                                        </span>
                                    </div>
                                    <div className={clsx(styles.input)}>
                                        <div
                                            className={clsx(styles.dropdown)}
                                            onClick={() => setOpenTypeScore(!openTypeScore)}
                                        >
                                            <div className={clsx(styles.dropdownName)}>
                                                {typeScore
                                                    ? typeScores[typeScore][Object.keys(typeScores[typeScore])[0]]
                                                    : 'Select type score...'}
                                            </div>
                                            <div className={clsx(styles.dropdownIcon)}>
                                                {openTypeScore && <FontAwesomeIcon icon={faAngleUp} />}
                                                {!openTypeScore && <FontAwesomeIcon icon={faAngleDown} />}
                                            </div>
                                        </div>
                                        {openTypeScore && (
                                            <div className={clsx(styles.dropdownBody)}>
                                                {typeScores.map((type_score, indexOfTypeScore) => {
                                                    let key = Object.keys(type_score)[0];
                                                    console.log(type_score[key]);
                                                    return (
                                                        <div
                                                            className={clsx(styles.dropdownItem)}
                                                            onClick={() => handleSelectTypeScore(key)}
                                                        >
                                                            <div className={clsx(styles.dropdownItemTitle)}>
                                                                {type_score[key]}
                                                            </div>
                                                            {typeScore && typeScore === key && (
                                                                <div className={clsx(styles.dropdownItemIcon)}>
                                                                    <FontAwesomeIcon icon={faCheck} />
                                                                </div>
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className={clsx(styles.formInput)}>
                                    <div className={clsx(styles.label)}>
                                        Description
                                        <span>
                                            <FontAwesomeIcon icon={faCircleExclamation} />
                                        </span>
                                    </div>
                                    <div className={clsx(styles.input)}>
                                        <textarea
                                            type="text"
                                            className={clsx('form-control', styles.textarea)}
                                            id="exampleFormControlInput1"
                                            placeholder="Type your description about the question here."
                                            value={description}
                                            onChange={(event) => handleChangeDescription(event.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className={clsx(styles.formField)}>
                        <div
                            className={clsx(styles.formTitle)}
                            onClick={() => {
                                handleOpenFieldForms(6);
                            }}
                        >
                            <div className={clsx(styles.title)}>Timer</div>
                            <div className={clsx(styles.formDropdown)}>
                                {openFieldForms[6] && <FontAwesomeIcon icon={faAngleUp} />}
                                {!openFieldForms[6] && <FontAwesomeIcon icon={faAngleDown} />}
                            </div>
                        </div>
                        {openFieldForms[6] && (
                            <div>
                                <div className={clsx(styles.formInput)}>
                                    <div className={clsx(styles.label)}>
                                        Start Time{' '}
                                        <span>
                                            <FontAwesomeIcon icon={faCircleExclamation} />
                                        </span>
                                    </div>
                                    <div className={clsx(styles.input)}>
                                        <DateTimePicker onChange={setStartTime} value={startTime} />
                                    </div>
                                </div>
                                <div className={clsx(styles.formInput)}>
                                    <div className={clsx(styles.label)}>
                                        End Time
                                        <span>
                                            <FontAwesomeIcon icon={faCircleExclamation} />
                                        </span>
                                    </div>
                                    <div className={clsx(styles.input)}>
                                        <DateTimePicker onChange={setEndTime} value={endTime} />
                                    </div>
                                </div>
                                <div className={clsx(styles.formInput)}>
                                    <div className={clsx(styles.label)}>
                                        Time Limit
                                        <span>
                                            <FontAwesomeIcon icon={faCircleExclamation} />
                                        </span>
                                    </div>
                                    <div className={clsx(styles.input)}>
                                        <TimePicker onChange={setTimeLimit} value={timeLimit} />
                                    </div>
                                </div>
                                <div className={clsx(styles.formInput)}>
                                    <div className={clsx(styles.label)}>
                                        Retries
                                        <span>
                                            <FontAwesomeIcon icon={faCircleExclamation} />
                                        </span>
                                    </div>
                                    <div className={clsx(styles.input)}>
                                        <input
                                            type="number"
                                            className={clsx('form-control', styles.formControl)}
                                            id="exampleFormControlInput1"
                                            value={retries}
                                            onChange={(event) => handleChangeRetries(event.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    {languages_.length > 0 &&
                        languages_.map((lang, indexLang) => {
                            return (
                                <div className={clsx(styles.formField)}>
                                    <div
                                        className={clsx(styles.formTitle)}
                                        onClick={() => {
                                            handleOpenFieldForms(lang.id);
                                        }}
                                    >
                                        <div className={clsx(styles.title)}>Code {lang.name}</div>
                                        <div className={clsx(styles.formDropdown)}>
                                            {openFieldForms[lang.id] && <FontAwesomeIcon icon={faAngleUp} />}
                                            {!openFieldForms[lang.id] && <FontAwesomeIcon icon={faAngleDown} />}
                                        </div>
                                    </div>
                                    {openFieldForms[lang.id] && (
                                        <div>
                                            <div className={clsx('d-flex', 'align-items-center, pt-3')}>
                                                <div className={clsx(styles.label)}>Initial Code</div>
                                                <div className={clsx(styles.input, styles.inputCode)}>
                                                    <CodeMirror
                                                        value={initialCodes[lang.id]}
                                                        extensions={[
                                                            lang.name === 'cpp' ? langs.cpp() : langs.python(),
                                                        ]}
                                                        onChange={(val) => handleChangeCode(val, lang, 'initial')}
                                                        onClick={() => {
                                                            handleCheckEmpty('initialCode');
                                                        }}
                                                        theme={theme === 'light' ? xcodeLight : dracula}
                                                    />
                                                </div>
                                            </div>
                                            <div className={clsx('d-flex', 'align-items-center, pt-3')}>
                                                <div className={clsx(styles.label)}>Solution Code</div>
                                                <div className={clsx(styles.input, styles.inputCode)}>
                                                    <CodeMirror
                                                        value={solutionCodes[lang.id]}
                                                        extensions={[
                                                            lang.name === 'cpp' ? langs.cpp() : langs.python(),
                                                        ]}
                                                        onChange={(val) => handleChangeCode(val, lang, 'solution')}
                                                        onClick={() => {
                                                            handleCheckEmpty('solutionCode');
                                                        }}
                                                        theme={theme === 'light' ? xcodeLight : dracula}
                                                    />
                                                </div>
                                            </div>
                                            <div className={clsx('d-flex', 'align-items-center, pt-3')}>
                                                <div className={clsx(styles.label)}>Full Code</div>
                                                <div className={clsx(styles.input, styles.inputCode)}>
                                                    <CodeMirror
                                                        value={fullCodes[lang.id]}
                                                        extensions={[
                                                            lang.name === 'cpp' ? langs.cpp() : langs.python(),
                                                        ]}
                                                        onChange={(val) => handleChangeCode(val, lang, 'full')}
                                                        onClick={() => {
                                                            handleCheckEmpty('initialCode');
                                                        }}
                                                        theme={theme === 'light' ? xcodeLight : dracula}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        })}

                    <div className={clsx(styles.formField)}>
                        <div
                            className={clsx(styles.formTitle)}
                            onClick={() => {
                                handleOpenFieldForms(3);
                            }}
                        >
                            <div className={clsx(styles.title)}>Testcases</div>
                            <div className={clsx(styles.formDropdown)}>
                                {openFieldForms[3] && <FontAwesomeIcon icon={faAngleUp} />}
                                {!openFieldForms[3] && <FontAwesomeIcon icon={faAngleDown} />}
                            </div>
                        </div>
                        {openFieldForms[3] && (
                            <div>
                                <div className={clsx(styles.testCaseField)}>
                                    <div
                                        className={clsx(styles.testCaseHeader)}
                                        onClick={() => {
                                            handleOpenFieldForms(4);
                                        }}
                                    >
                                        <div className={clsx(styles.testCaseIcon)}>
                                            {openFieldForms[4] && <FontAwesomeIcon icon={faAngleDown} />}
                                            {!openFieldForms[4] && <FontAwesomeIcon icon={faAngleRight} />}
                                        </div>
                                        <div className={clsx(styles.testCaseTitle)}>Add new testcase...</div>
                                    </div>
                                    {openFieldForms[4] && (
                                        <div className={clsx(styles.testCaseFillField)}>
                                            <div className={clsx(styles.testCaseFillItem)}>
                                                <div className={clsx(styles.label)}>Standard Input</div>
                                                <div className={clsx(styles.input)}>
                                                    <input
                                                        type="text"
                                                        className={clsx('form-control', styles.formControl)}
                                                        id="exampleFormControlInput1"
                                                        value={inputTestcase}
                                                        onChange={(event) =>
                                                            handleChangeInputTestcase(event.target.value)
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <div className={clsx(styles.testCaseFillItem)}>
                                                <div className={clsx(styles.label)}>Expected Output</div>
                                                <div className={clsx(styles.input)}>
                                                    <input
                                                        type="text"
                                                        className={clsx('form-control', styles.formControl)}
                                                        id="exampleFormControlInput1"
                                                        value={outputTestcase}
                                                        onChange={(event) =>
                                                            handleChangeOutputTestcase(event.target.value)
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <div className={clsx('d-flex', styles.testCaseFillField)}>
                                                <div
                                                    className={clsx(
                                                        styles.button,
                                                        styles.buttonAdd,
                                                        styles.buttonAddTestcase,
                                                    )}
                                                    onClick={handleAddTestcase}
                                                >
                                                    Add
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className={clsx(styles.testCaseField)}>
                                    <div
                                        className={clsx(styles.testCaseHeader)}
                                        onClick={() => {
                                            handleOpenFieldForms(5);
                                        }}
                                    >
                                        <div className={clsx(styles.testCaseIcon)}>
                                            {openFieldForms[5] && <FontAwesomeIcon icon={faAngleDown} />}
                                            {!openFieldForms[5] && <FontAwesomeIcon icon={faAngleRight} />}
                                        </div>
                                        <div className={clsx(styles.testCaseTitle)}>Testcase Review</div>
                                    </div>
                                    {openFieldForms[5] && (
                                        <div className={clsx(styles.testCaseReviewField)}>
                                            <div
                                                className={clsx(
                                                    'd-flex',
                                                    'align-items-center',
                                                    styles.testCaseTableHeader,
                                                )}
                                            >
                                                <div className={clsx(styles.textCenter, styles.borderCol, 'col-6')}>
                                                    Standard Input
                                                </div>
                                                <div className={clsx(styles.textCenter, styles.borderCol, 'col-6')}>
                                                    Expected Output
                                                </div>
                                            </div>
                                            <div className={clsx(styles.testCaseTableBody)}>
                                                {testcases.map((testcase, idxTestcase) => {
                                                    return (
                                                        <div className={clsx('d-flex', styles.testCaseTableRow)}>
                                                            <div
                                                                className={clsx(
                                                                    styles.textCenter,
                                                                    styles.borderCol,
                                                                    'col-6',
                                                                )}
                                                            >
                                                                {testcase.input}
                                                            </div>
                                                            <div
                                                                className={clsx(
                                                                    styles.textCenter,
                                                                    styles.borderCol,
                                                                    'col-6',
                                                                )}
                                                            >
                                                                {testcase.output}
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                        <div
                            className={clsx(
                                'd-flex',
                                'align-items-center',
                                'justify-content-center',
                                'pt-5',
                                styles.testCaseFillItem,
                            )}
                        >
                            <div className={clsx(styles.button, styles.buttonAdd)} onClick={handleSubmitExercise}>
                                Save and back to my class
                            </div>
                            <div className={clsx(styles.button, styles.buttonCancel)}>Cancel</div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

const AddExercise = () => {
    return <CourseComponent state="course" mainChild={<MainChild />} />;
};

export default AddExercise;
